<template>
  <div class="timer">
    <div class="frame">
      <div class="time">{{ ("00" + value).slice(-2) }}</div>
    </div>
    <div class="caption">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: ["title", "value"]
};
</script>

<style lang="scss" scoped>
.timer {
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-align: center;
  font-size: 0.625rem;
  margin: 0 5px;
  .frame {
    border-radius: 6px;
    // border-width: 22px;
    background-color: #e20186;
    display: inline-block;

    .time {
      font-size: 0.675rem;
      padding: 4px 16px;
    }
  }

  .caption {
    text-transform: uppercase;
  }
}

@media (max-width: 768px) {
  .timer .frame .time {
    padding: 8px;
  }
  .caption {
    margin-top: 6px;
  }
}
</style>
